<template>
  <div class="site-card">
    <div class="panel panel-default contact-card card-view">
      <div :class="site.forbidden ? 'panel-heading bg-danger' : 'panel-heading bg-orange'">
        <div class="pull-left" style="width: 70%">
          <div class="pull-left user-detail-wrap">
            <span class="block card-user-name">
              <router-link class="base-link"
                v-tooltip.hover
                :title="site.name"
                :to="`/sites/${site.id}`">{{site.name}}</router-link>
            </span>
            <span class="block card-user-desn"
              v-tooltip.hover
              :title="site.postal_address">{{site.postal_address}}</span>
          </div>
        </div>
        <div class="pull-right" v-if="needEdit">
            <a class="inline-block mr-15 action-button">
              <i @click="deleteSite(site.id)" class="zmdi zmdi-delete txt-light"></i>
            </a>
          </div>
        <div class="clearfix"></div>
      </div>
      <div class="panel-wrapper collapse in">
        <div class="panel-body row">
          <div class="">
            <div class="row ml-0 mr-0">
              <div class="col-sm-12 identifier-field">
                <span class="inline-block txt-dark">{{$t(`app.sites.details`)}}</span>
              </div>
            </div>
          </div>
          <div class="pr-15">
            <div class="row ml-15 mr-0 data-row">
              <div class="col-sm-6 pl-0">
                <span class="txt-dark">{{$t('app.sites.site_card.land_register_reference', {locale: 'en'})}}</span>
              </div>
               <div class="col-sm-6 pl-0">
                <span class="inline-block"
                >{{site.land_register_reference}}</span>
              </div>
            </div>
          </div>
          <div class="pr-15">
            <div class="row ml-15 mr-0 data-row">
              <div class="col-sm-6 pl-0">
                <span class="txt-dark">{{$t('app.sites.site_card.eov_x')}}</span>
              </div>
               <div class="col-sm-6 pl-0">
                <span class="inline-block"
                >{{site.eov_x}}</span>
              </div>
            </div>
          </div>
          <div class="pr-15 mb-10">
            <div class="row ml-15 mr-0 data-row">
              <div class="col-sm-6 pl-0">
                <span class="txt-dark">{{$t('app.sites.site_card.eov_y')}}</span>
              </div>
               <div class="col-sm-6 pl-0">
                <span class="inline-block">{{site.eov_y}}</span>
              </div>
            </div>
          </div>
          <div class="pr-15">
            <div class="row ml-15 mr-0 data-row">
              <div class="col-sm-6 pl-0">
                <span
                  class="inline-block txt-dark contact-field"
                >{{$t('app.sites.site_card.contact_title')}}</span>
              </div>
            </div>
          </div>
          <div class="pr-15">
            <div class="row ml-15 mr-0 data-row">
              <div class="col-sm-6 pl-0">
                <span
                  class="inline-block"
                >{{site.contact}}</span>
              </div>
            </div>
          </div>
          <div class="pr-15">
            <div class="row ml-15 mr-0 data-row">
              <div class="col-sm-6 pl-0">
                <span
                  class="inline-block"
                >{{site.contact_phone}}</span>
              </div>
            </div>
          </div>
          <div class="pr-15">
            <div class="row ml-15 mr-0 data-row">
              <div class="col-sm-6 pl-0">
                <span
                  class="inline-block"
                >{{site.contact_email}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/shared/buttons/BaseButton';

export default {
  name: 'SiteCard',
  components: {
    'base-button': BaseButton,
  },
  props: {
    site: {
      type: Object,
      required: true,
    },
    needEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    selectSite(id) {
      this.$emit('selectSite', { actionType: 'edit', id });
    },
    deleteSite(id) {
      this.$emit('deleteSite', id);
    },
  },
};
</script>

<style scoped lang="scss">

.site-card {
  @media (max-width: 1400px) {
    font-size: 10px;
  }
}

.image-container {
  display: flex;
  justify-content: center;
  height: 170px;

  img {
    max-height: 170px;
    width: auto;
  }
}

.panel-heading {
  min-height: 76px;
}

.user-detail-wrap {
  width: 100%;
}

.mb-15 {
  @media (max-width: 1400px) {
    margin-bottom: 5px !important;
  }
}
.emp-detail {
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-button {
  cursor: pointer;
}
.base-link {
  font-weight: bold;
  color: white;
}
.col-sm-6, .card-user-desn, .card-user-name {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.col-sm-4 {
  white-space: nowrap;
}

.contact-field, .identifier-field {
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/modules/partners/SiteCard.vue